import { render, staticRenderFns } from "./ClaimListing.vue?vue&type=template&id=2f045e37&"
import script from "./ClaimListing.vue?vue&type=script&lang=js&"
export * from "./ClaimListing.vue?vue&type=script&lang=js&"
import style0 from "./ClaimListing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimListing.vue"
export default component.exports